import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-access-control-card-list',
  templateUrl: './access-control-card-list.component.html',
  styleUrls: ['./access-control-card-list.component.scss'],
  standalone: false,
})
export class AccessControlCardListComponent implements OnInit {
  @Input() name: string;
  @Input() label: string;
  @Input() cardList: object[];
  @Input() permissionList: number[];
  @Input() editing: boolean;
  categorizedByFilingYear = {};
  hideCollapsedArrow: boolean = false;
  expandedYears: { [year: string]: boolean } = {};

  constructor() {}

  ngOnInit() {
    if (['Tax Return', 'Tax Documentation'].includes(this.name)) {
      this.cardList.forEach((cardData) => {
        const filingYear = cardData['filingYear'];
        if (!this.categorizedByFilingYear[filingYear]) {
          this.categorizedByFilingYear[filingYear] = [];
        }
        this.categorizedByFilingYear[filingYear].push(cardData);
      });
      if (Object.keys(this.categorizedByFilingYear).length === 1) {
        const onlyYear = Object.keys(this.categorizedByFilingYear)[0];
        this.expandedYears[onlyYear] = true;
        this.hideCollapsedArrow = true;
      }
    }
  }

  get showGroupedByYear(): boolean {
    const isTaxName = ['Tax Return', 'Tax Documentation'].includes(this.name);
    const hasGroups = Object.keys(this.categorizedByFilingYear).length > 0;
    return isTaxName && hasGroups;
  }

  addToPermissionList(item: any, list: number[]) {
    if (list.indexOf(item.id) < 0) {
      list.push(item.id);
    } else {
      list.splice(list.indexOf(item.id), 1);
    }
  }

  toggleYear(year: string) {
    if (!this.hideCollapsedArrow && this.shouldShowCollapseArrow(year)) {
      this.expandedYears[year] = !this.expandedYears[year];
    }
  }

  isYearExpanded(year: string): boolean {
    return !!this.expandedYears[year];
  }

  shouldShowCollapseArrow(year: string): boolean {
    if (this.editing) {
      return true;
    }

    const yearItems = this.categorizedByFilingYear[year] || [];
    return yearItems.some(
      (item) =>
        this.permissionList.indexOf(item.id) >= 0 || item.allowAllDesignee
    );
  }
}
